<template>
    <div class="tabs_content" v-if="!loading">
      <section>
        <div class="status"><h2 v-translate>Přiřazení odběratelé</h2>
          <h2>&nbsp;({{ biller.subscribers.length }})</h2></div>

        <div class="scroll-wrapper">
          <div class="table_overflow" id="contentBox" data-table-id="billers-subscribers">
            <table class="vypis">
              <thead>
              <tr v-if="biller.subscribers && biller.subscribers.length > 0">
                <th class="no_padding drag_drop"></th>
                <th class="no_padding checkbox"></th>
                <sorting-table-title
                    v-for="title in sortingTableTitles"
                    :key="title.id"
                    :column="title.column"
                    :sort="getActiveSort(title.column)"
                    :extra-style="title.style"
                    @changeSorting="changeSorting"
                >{{ title.name }}
                </sorting-table-title>
                <th class="no_padding"></th>
              </tr>
              </thead>
              <tr v-for="entity in entities" :key="entity.id" @click.stop="showSubscriberDetail(entity.id)"
                  :class="{'clickable': $_loggedUser_action_allowed('subscribers')}">
                <td class="no_padding drag_drop"><span></span></td>
                <td class="no_padding">
                  <input type="checkbox"
                         :id="entity.id"
                         :value="entity.id"
                         v-model="selectedEntities"
                         @click.stop
                  />
                  <label :for="entity.id" @click.stop v-translate>Vybrat</label>
                </td>
                <td data-th="Id odběratele">{{ entity.id_remote }}</td>
                <td data-th="Jméno odběratele"><strong>{{ entity.name_subscriber }}</strong></td>
                <td data-th="Název firmy">{{ entity.name_company }}</td>
                <td data-th="Vytvořeno" v-html="$_date_formatFull(entity.timestamp_created)"></td>
                <td class="no_padding"></td>
              </tr>
              <tr v-if="!biller.subscribers || biller.subscribers.length === 0">
                <td colspan="6">{{ $gettext("Nebyli přiřazeni žádní odběratelé.") }}</td>
              </tr>
            </table>
          </div>
        </div>
        <local-list-action-line
            :entities="entities"
            :selected-entities="selectedEntities"
            :multiple-action-options="multipleActionOptions"
            table-id="billers-subscribers"
            @select-all="toggleSelectAll"
            @run-multiple-action="runMultipleAction"
        ></local-list-action-line>
      </section>
    </div>
</template>

<script>
import SortingTableTitle from "../../../common/SortingTableTitle";
import localTable from "@/components/mixins/local-table"
import links from "../../../mixins/links";

export default {
    name: "SubscriberList",
    components: {SortingTableTitle},
    props: ["biller", "loading"],
    mixins: [localTable, links],
    data () {
        return {
            moduleName: "billerSubscriberList",
        }
    },
    computed: {
      sortingTableTitles() {
        return [
          {id: 1, name: this.$gettext('ID odběratele'), column: 'id_remote', style: {minWidth: '130px'}},
          {id: 2, name: this.$gettext('Jméno odběratele'), column: 'name_subscriber'},
          {id: 3, name: this.$gettext('Název firmy'), column: 'name_company'},
          {id: 4, name: this.$gettext('Vytvořeno'), column: 'timestamp_created'}
        ]
      },
      entities() {
        return this.biller.subscribers.sort(this.getSortingFunction());
      },
      csvHeaders(){
        let headers = this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles);
        headers.timestamp_created.callback = (entity) => {return entity.timestamp_created ? this.$_datetime_format(entity.timestamp_created) : ''; };

        return headers;
      },
    },
    methods: {
        getDefaultSorting() {
            return {column: 'name_subscriber', direction: 'asc' };
        },
        getSortingFunction() {
            return (subscriberA, subscriberB) => {
                let sortResult = 0;

                switch (this.sort.column) {
                    case 'id_remote':
                    case 'name_subscriber':
                    case 'name_company':
                        sortResult = this.stringCompare(subscriberA[this.sort.column], subscriberB[this.sort.column]);
                        break;
                    case 'timestamp_created':
                        sortResult = this.integerCompare(subscriberA[this.sort.column], subscriberB[this.sort.column]);
                        break;
                }

                return this.sort.direction === "asc" ? sortResult : (-1) * sortResult;
            }
        }
    },
}

</script>



// WEBPACK FOOTER //
// src/components/views/billers/billerDetail/SubscriberList.vue